import { useState } from "react";
import { ScrollText } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { useApp } from "../context/AppContext";
import { useAuth } from "../context/AuthContext";
import { acceptTerms, apiErrorMessage } from "../lib/api";

// One-time consent gate for parents without a recorded terms acceptance.
export function TermsGate() {
  const { t } = useApp();
  const { user, role, refreshUser } = useAuth();
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const open = !!user && role === "parent" && !user.terms_accepted_at;
  if (!open) return null;
  const submit = async () => {
    setBusy(true);
    try { await acceptTerms(); await refreshUser(); toast.success(t("termsAccepted")); } catch (e) { toast.error(apiErrorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open>
      <DialogContent data-testid="terms-gate" className="rounded-3xl max-w-md" onPointerDownOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()} hideClose>
        <div className="w-12 h-12 rounded-2xl bg-teal-50 text-teal-700 grid place-items-center"><ScrollText size={22} /></div>
        <DialogTitle className="font-display font-bold text-xl text-slate-800">{t("termsUpdatedTitle")}</DialogTitle>
        <DialogDescription className="text-slate-600">{t("termsUpdatedDesc")}</DialogDescription>
        <label className="flex items-start gap-3 bg-slate-50 border-2 border-slate-200 rounded-xl px-4 py-3 cursor-pointer has-[:checked]:border-teal-400" data-testid="terms-gate-label">
          <input data-testid="terms-gate-agree" type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} className="mt-1 h-5 w-5 accent-teal-600 shrink-0" />
          <span className="text-sm font-semibold text-slate-600">{t("agreeTermsPre")} <a href="/terms" target="_blank" rel="noopener noreferrer" data-testid="terms-gate-link" className="text-teal-700 font-bold underline underline-offset-2">{t("termsAndConditions")}</a></span>
        </label>
        <button data-testid="terms-gate-continue" disabled={!agree || busy} onClick={submit} className="w-full bg-teal-600 hover:bg-teal-700 disabled:opacity-40 text-white font-bold py-3 rounded-2xl transition-colors">{t("termsContinue")}</button>
      </DialogContent>
    </Dialog>
  );
}
